import { base44 } from "@/api/base44Client";

// Anonymous, category-level journey events. No names, emails, coordinates,
// search terms, addresses, or full external URLs are included in event payloads.
const allowedProperties = new Set(["origin","area","provider","stop_count","destination","section","page"]);
export function trackGuideAction(eventName, properties = {}) {
  try {
    if (Reflect.get(navigator, "globalPrivacyControl") === true || navigator.doNotTrack === "1") return;
    if (window.localStorage.getItem("yts:analytics:consent") === "no") return;
    const safe = Object.fromEntries(Object.entries(properties)
      .filter(([key]) => allowedProperties.has(key))
      .map(([key,value]) => [key, typeof value === "number" ? value : String(value).slice(0,64)]));
    Promise.resolve(base44.analytics.track({ eventName, properties: safe })).catch(() => {});
  } catch { /* Analytics failures never interrupt browsing. */ }
}
export function validPublicUrl(value) {
  if (!value) return "";
  try {
    const url = new URL(String(value));
    return url.protocol === "https:" || url.protocol === "http:" ? url.toString() : "";
  } catch { return ""; }
}
export function journeyRoute(pathname) {
  if (pathname === "/make-a-day") return "itinerary";
  if (pathname === "/events") return "events";
  if (pathname === "/magazine" || pathname.startsWith("/magazine/")) return "editorial";
  if (pathname.startsWith("/experience/")) return "experience";
  if (pathname === "/map") return "map";
  if (pathname === "/planner" || pathname === "/saved") return "saved";
  if (/^\/(Santurce|RioPiedras|Condado)(\/|$)/i.test(pathname)) return "flagship_neighborhood";
  if (pathname.startsWith("/districts")) return "district";
  return "";
}
export function captureGuideClick(event) {
  const anchor = event.target?.closest?.("a[href]");
  if (!anchor) return;
  let target;
  try { target = new URL(anchor.getAttribute("href"), window.location.href); } catch { return; }
  const host = target.hostname.toLowerCase();
  const external = target.origin !== window.location.origin;
  if (!external) {
    const section = journeyRoute(target.pathname);
    if (section) trackGuideAction("guide_navigation_click", { section, origin: journeyRoute(window.location.pathname) || "other" });
    return;
  }
  if (/google\.[^/]+$/.test(host) && /maps/.test(target.href) || host === "waze.com" || host.endsWith(".waze.com")) {
    trackGuideAction("guide_directions_click", { origin: journeyRoute(window.location.pathname) || "listing" });
  } else if (host.includes("fareharbor.com") || host.includes("viator.com") || host.includes("getyourguide.com") || /booking|reserve|book|tickets/i.test(anchor.textContent || "")) {
    const provider = host.includes("fareharbor") ? "FareHarbor" : host.includes("viator") ? "Viator" : host.includes("getyourguide") ? "GetYourGuide" : "external";
    trackGuideAction("guide_booking_click", { provider, origin: journeyRoute(window.location.pathname) || "listing" });
  } else if (anchor.closest(".yts-listing-profile")) {
    trackGuideAction("guide_business_outbound_click", { origin: "listing" });
  }
}
